// extracted by mini-css-extract-plugin
export default {"card":"MT-z","defaultCard":"NT-z","cardDetails":"OT-z","cardActions":"PT-z","separator":"QT-z"};